import cn from "lib/cn";

import styles from "./Card.module.css";

interface CardProps {
  children: React.ReactNode;
  containerClassName?: string;
  className?: string;
}

const Card = ({ children, className, containerClassName }: CardProps) => {
  return (
    <div className={cn("w-full h-full", className)}>
      <div
        className={cn(
          "bg-white rounded-xl py-4 px-4 w-full h-full",
          styles.container,
          containerClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Card;
